import {
  getMetaData,
  updateMetaData,
  updateAdvancedMetaData,
  updateIndicator,
  updateIndicatorPosition,
} from '@/api';
import huasiLogo from '@/assets/images/huasi_logo.png';

const localState = {
  metaData: {
    corpName: '',
    version: '',
    copyright: '',
    logo: '',
    slogan: '',
    degX: 0,
    degY: 0,
    degA: 0,
    degB: 0,
    degX2: 0,
    degY2: 0,
    degA2: 0,
    degB2: 0,
    direction: 0,
    directionRemarks: '',
    indicatorTop: '',
    indicatorLeft: '',
    indicator2Top: '',
    indicator2Left: '',
    directionIndicatorTop: '',
    directionIndicatorLeft: '',
  }, // 云平台元数据
};

const getters = {
  corpName: state => state.metaData.corpName,
  version: state => state.metaData.version,
  copyright: state => state.metaData.copyright
    || 'Copyright 2017 - 2019 华思（广州）测控科技有限公司 All Rights Reserved.',
  slogan: state => state.metaData.slogan
    || '欢迎使用华思四维变形监测系统',
  logo: state => state.metaData.logo || huasiLogo,
  enableMissingInsert: state => state.metaData.enableMissingInsert || false,
  degX: state => state.metaData.degX,
  degY: state => state.metaData.degY,
  degA: state => state.metaData.degA,
  degB: state => state.metaData.degB,
  degX2: state => state.metaData.degX2,
  degY2: state => state.metaData.degY2,
  degA2: state => state.metaData.degA2,
  degB2: state => state.metaData.degB2,
  direction: state => state.metaData.direction,
  directionRemarks: state => state.metaData.directionRemarks,
  indicatorTop: state => state.metaData.indicatorTop,
  indicatorLeft: state => state.metaData.indicatorLeft,
  indicator2Top: state => state.metaData.indicator2Top,
  indicator2Left: state => state.metaData.indicator2Left,
  directionIndicatorTop: state => state.metaData.directionIndicatorTop,
  directionIndicatorLeft: state => state.metaData.directionIndicatorLeft,
};

const actions = {
  async fetchMetaData({ commit }) {
    const res = await getMetaData();
    commit('setMetaData', res.data.metaData);
    // 使用 slogan 设置页面 title
    if (res.data.metaData && res.data.metaData.slogan) {
      document.title = res.data.metaData.slogan;
    } else {
      document.title = '欢迎使用华思四维变形监测系统';
    }
  },
  async updateMetaData({ commit }, metaForm) {
    const { corpName, copyright, slogan } = metaForm;
    const res = await updateMetaData({ corpName, copyright, slogan });
    commit('setMetaData', res.data.metaData);
  },
  async updateAdvancedMetaData({ commit }, metaForm) {
    const { enableMissingInsert } = metaForm;
    const res = await updateAdvancedMetaData({ enableMissingInsert });
    commit('setMetaData', res.data.metaData);
  },
  async updateIndicator({ commit }, indicatorForm) {
    const { degX, degY, degA, degB } = indicatorForm;
    const res = await updateIndicator({ degX, degY, degA, degB });
    commit('setMetaData', res.data.metaData);
  },
  async updateIndicator2({ commit }, indicatorForm) {
    const { degX2, degY2, degA2, degB2 } = indicatorForm;
    const res = await updateIndicator({ degX2, degY2, degA2, degB2 });
    commit('setMetaData', res.data.metaData);
  },
  async updateDirectionIndicator({ commit }, indicatorForm) {
    const { direction, directionRemarks } = indicatorForm;
    const res = await updateIndicator({ direction, directionRemarks });
    commit('setMetaData', res.data.metaData);
  },
  async updateIndicatorPosition({ commit }, { type, top, left }) {
    let payload;
    switch (type) {
      case 'DIRECTION_INDICATOR':
        payload = { directionIndicatorTop: top, directionIndicatorLeft: left };
        break;
      case 'INDICATOR1':
        payload = { indicatorTop: top, indicatorLeft: left };
        break;
      case 'INDICATOR2':
        payload = { indicator2Top: top, indicator2Left: left };
        break;
      default:
        throw new Error('错误的图示类型');
    }
    const res = await updateIndicatorPosition(payload);
    commit('setMetaData', res.data.metaData);
  },
};

const mutations = {
  setMetaData(state, metaData) {
    state.metaData = metaData;
  },
};

export default {
  getters,
  actions,
  mutations,
  state: localState,
  namespaced: true,
};

